import React from "react";
import "./services.css";
import heart from "../../assets/images/favourites/heart.png";
import emptyBanner from "../../assets/images/emptybanner.png";
import { useHistory } from "react-router-dom";

const ServiceCard = ({ item, type }) => {
  const history = useHistory();
  return (
    <div
      className="card service-card cp"
      onClick={() => {
        history.push(`/business-details/${item?.id}`);
      }}
    >
      <div className="service-card-top-img">
        <img
          src={item?.pictures[0]?.photo_path || emptyBanner}
          alt="Card Image"
        />
      </div>
      {type && type === "favourite" && (
        <div className="service-card-icon p-2">
          <img src={heart} />
        </div>
      )}

      <div className="card-body p-20 d-flex flex-column justify-content-between">
        <div className={`container-fluid pb-12`}>
          <div
            className={`row align-items-center justify-content-between lh-0`}
          >
            <div className={`col-auto px-0px d-flex flex-wrap gap-1 h-36 align-items-center`}>
              {Array.isArray(item?.categories) &&
                item.categories.slice(0, 4).map((cat, i) => (
                  <span
                    className="badge color-primary poppins f-12 fw-normal lh-16 py-4rem px-12 bg-gold br-16 d-flex align-items-center"
                    key={i}
                  >
                    {cat}
                  </span>
                ))}
              {Array.isArray(item?.categories) && item.categories.length > 4 && <p className="mb-0">+{item?.categories.length - 4} <span className="text-decoration-underline ">more</span></p>}
            </div>
          </div>
        </div>
        <div>
          <div className="d-flex justify-content-between align-items-center gap-2">
            <h5 className={`c-0f151d f-16 fw-normal lh-24 poppins nearby-business-name`}>
              {item?.name}
            </h5>
            <div className={`d-flex gap-2 mb-8`}>
              <h6 className={`m-0 c-0f151d poppins f-12 fw-normal lh-16`}>
                5.0
              </h6>
              <div className={`col-auto px-0px lh-0`}>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_252_296)">
                    <path
                      d="M2.44884 11.6623C2.40084 11.6623 2.35284 11.6383 2.30484 11.6143C2.23284 11.5663 2.18484 11.4463 2.20884 11.3503L3.26484 7.41428L0.0968438 4.84628C0.000843818 4.79828 -0.0231562 4.67828 0.000843815 4.58228C0.0248438 4.48628 0.120844 4.41428 0.216844 4.41428L4.29684 4.19828L5.76084 0.382281C5.80884 0.310281 5.90484 0.238281 6.00084 0.238281C6.09684 0.238281 6.19284 0.310281 6.21684 0.382281L7.68084 4.19828L11.7608 4.41428C11.8568 4.41428 11.9528 4.48628 11.9768 4.58228C12.0008 4.67828 11.9768 4.77428 11.9048 4.84628L8.73684 7.41428L9.79284 11.3503C9.81684 11.4463 9.79284 11.5423 9.69684 11.6143C9.62484 11.6623 9.50484 11.6863 9.43284 11.6143L6.00084 9.40628L2.56884 11.6143C2.52084 11.6623 2.49684 11.6623 2.44884 11.6623Z"
                      fill="#2b5c35"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_252_296">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h6 className={`m-0 c-0f151d poppins f-12 fw-normal lh-16`}>
                (12)
              </h6>
            </div>
          </div>
          <h6
            className={`c-667085 f-14 fw-normal lh-20 poppins m-0 nearby-business-address`}
          >
            {item?.address}
          </h6>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
